import { defineComponent, PropType, Transition } from 'vue'
import * as styles from '@/components/atoms/fade/Fade.css'

export const FadeFromBottom = defineComponent({
  name: 'FadeFromBottom',
  props: {
    appear: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String as PropType<'default' | 'out-in' | 'in-out'>,
      default: 'default',
    },
    css: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { slots }) {
    return () => (
      <Transition
        mode={props.mode}
        appear={props.appear}
        enter-active-class={styles.activeFadeTransform}
        leave-active-class={styles.activeFadeTransform}
        enter-from-class={styles.initialFadeTransform}
        leave-to-class={styles.initialFadeTransform}
        css={props.css}
      >
        {slots.default?.()}
      </Transition>
    )
  },
})
